import React, { useState } from 'react';
import './AssignTicketModal.css';
import { X, Layers } from 'lucide-react';
import { updateAssignTo } from './Workloadapi';
import SearchWithAPI from '../common/searchbox/searchbox.js';

const apiUrl = process.env.REACT_APP_API_URL;

const AssignTicketModal = ({ ticket, onClose, onSuccess }) => {
  const [selectedTeamOption, setTeamOption] = useState(null);
  const [selectedEmailOption, setEmailOption] = useState(null);
  const [remarks, setRemarks] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  if (!ticket) return null;

  const handleTeamDropdownChange = (option) => {
    setTeamOption(option);
    setEmailOption(null); // Reset assignee when team changes
  };

  const handleEmailDropdownChange = (option) => {
    setEmailOption(option);
  };

  const handleAssign = async () => {
    if (!selectedTeamOption || !selectedEmailOption) {
      setError('Please select both Team and Assign to.');
      return;
    }

    setLoading(true);
    setError('');

    const payload = {
      id: ticket.id,
      team_id: selectedTeamOption.value,
      assign_to: selectedEmailOption.value,
      remarks: remarks
    };

    try {
      const response = await updateAssignTo(payload);

      if (response && response.data && response.data.success) {
        if (onSuccess) onSuccess();
        onClose();
        // Typically here we would trigger a refresh or toast, but onClose handles modal exit
      } else {
        if (response?.data?.error) {
          const errs = Object.values(response.data.error).flat().join(', ');
          setError(errs || 'Failed to update assignment');
        } else {
          setError(response?.data?.message || 'An error occurred.');
        }
      }
    } catch (err) {
      console.error("Assignment error:", err);
      setError("An unexpected error occurred.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="assign-modal-overlay" onClick={onClose}>
      <div className="assign-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="assign-modal-header">
          <h3 className="assign-modal-title">Assign ticket</h3>
          <button className="assign-close-btn" onClick={onClose}>
            <X size={16} />
          </button>
        </div>

        <div className="assign-ticket-info">
          <div className="assign-ticket-icon">
            <Layers size={18} />
          </div>
          <div className="assign-ticket-details">
            <p className="ticket-title">{ticket.ticket_id ? `${ticket.ticket_id} - ` : ''}{ticket.title}</p>
            <div className="assign-ticket-meta">
              <span>{ticket.project || ticket.team}</span>
              <span className="stat-dot">•</span>
              <span className="assign-ticket-status">{ticket.status}</span>
            </div>
          </div>
        </div>

        {error && <div style={{ color: '#FF4444', fontSize: '13px', marginBottom: '16px' }}>{error}</div>}

        <div className="form-group">
          <label className="form-label">Team <span style={{ color: "red" }}>*</span></label>
          <div className="form-select-wrapper" style={{ display: 'block' }}>
            <SearchWithAPI
              onDropdownChange={handleTeamDropdownChange}
              apiUrl={apiUrl + `get_team`}
              placeholder={"Select Team"}
              selectedValue={selectedTeamOption != null ? selectedTeamOption.label : ""}
              selectedOption={selectedTeamOption}
            />
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Assign to <span style={{ color: "red" }}>*</span></label>
          <div className="form-select-wrapper" style={{ display: 'block' }}>
            <SearchWithAPI
              onDropdownChange={handleEmailDropdownChange}
              apiUrl={apiUrl + `get_employee`}
              params={{
                team_id: (selectedTeamOption && selectedTeamOption.value) ?? "",
              }}
              placeholder={"Select Assignee"}
              selectedValue={selectedEmailOption != null ? selectedEmailOption.label : ""}
              selectedOption={selectedEmailOption}
            />
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Notes (Optional)</label>
          <textarea
            className="form-textarea"
            placeholder="Enter here..."
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
          ></textarea>
        </div>

        <div className="assign-modal-footer">
          <button className="btn-cancel" onClick={onClose} disabled={loading}>Cancel</button>
          <button className="btn-submit" onClick={handleAssign} disabled={loading}>
            {loading ? 'Assigning...' : 'Assign'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AssignTicketModal;
